import { createFileRoute, redirect } from "@tanstack/react-router";

// The marketing site lives at tuzidi.net (frontend-web). "/" on the app domain goes to
// the workspace so bookmarked links never 404; RouteGuard bounces signed-out visitors
// on to /login from there.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
});
